module.exports = __webpack_public_path__ + "static/media/08-Darmstadt@2x.81146032.jpg";